import { Search } from 'lucide-react';

export interface GsSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string; // appliqué sur le wrapper div
  autoFocus?: boolean;
  /**
   * 'pill' (défaut) = boîte bordée arrondie + focus ring brand — pour les toolbars de liste.
   * 'inline' = sans boîte (transparent, pas de bordure ni de ring) — pour les en-têtes étroits
   * (ex. en-tête de master-list 280px) où le CONTENEUR parent fournit le filet (border-b).
   * MASTER-DS-POLISH-PASS 2026-06-15.
   */
  variant?: 'pill' | 'inline';
}

export function GsSearchInput({
  value,
  onChange,
  placeholder,
  className = '',
  autoFocus,
  variant = 'pill',
}: GsSearchInputProps) {
  const inline = variant === 'inline';
  return (
    <div className={['relative', className].filter(Boolean).join(' ')}>
      <Search
        size={inline ? 15 : 14}
        className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400"
        aria-hidden
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className={
          inline
            ? 'w-full bg-transparent pl-8 pr-2 py-2 text-field text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 border-0 outline-none focus:outline-none focus:ring-0'
            : 'w-full pl-8 pr-3 py-2 border border-slate-200 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-800 text-field text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20 focus:border-brand-400 transition-colors'
        }
      />
    </div>
  );
}
